export default "__VITE_ASSET__a7e6f76f__"